module.exports = __webpack_public_path__ + "static/3-ddc96b464f52f4b10389d9adce7d843d.jpg";